import { create } from "zustand";
import { persist } from "zustand/middleware";

// please check src/action/auth-action.ts
interface User {
    username: string;
    email?: string;
    phone_number: string;
    is_business_owner: boolean;
}

type UserDataState = {
    userData: User;
    setUserData: (data: User) => void;
    deleteUserData: () => void;
}

export const useUserData = create<UserDataState>()(
    persist(
        (set) => ({
            userData: {
                username: "",
                email: "",
                phone_number: "",
                is_business_owner: false
            },
            setUserData: (data: User) => set({userData: data}),
            deleteUserData: () => set({
                userData: {
                    username: "",
                    email: "",
                    phone_number: "",
                    is_business_owner: false
                }
            }),
        }),
        {
            name: "user-data",
        }
    )
)